namespace SPA
{
	export namespace gui
	{
		export class Bootstrap
		{
			public static Column(className: string | string[] = ['col-sm-12'], ...content: any[]): JQuery
			{
				if (typeof className === 'string') {
					className = [className];
				}

				const column = ui.$$.div().addClass(className.join(' '));

				// JQuery | ui.base.BaseHTMLElement | ui.Form.BasicInputField
				for (const entry of content) {
					if (entry instanceof ui.Form.Input) {
						// @todo remove the nested not needed div tag
						entry.rebuild(column);
					} else if (entry instanceof ui.base.BaseHTMLElement) {
						// Added with events
						column.append(entry.Root());
					} else if (typeof entry === 'string') {
						column.append($(entry));
					} else {
						column.append(entry);
					}
				}

				return column;
			}

			public static TabNav(href: string, text: string, active: boolean = false): JQuery
			{
				const item = $('<li role="presentation">');
				if (active) {
					item.addClass('active');
				}

				const link = document.createElement('a');
				link.href = href;
				link.innerText = text;

				item.append(link);

				return $(item);
			}

			public static TabContent(id: string, content: string|JQuery, active: boolean = false): JQuery
			{
				const item = $('<div role="tabpanel" class="tab-pane c2 row">').attr('id', id);
				if (active)
				{
					item.addClass('active');
				}
				item.append(content);

				return item;
			}
		}
	}
}
